export const yyyymmdd = (dateIn) => {
  const yyyy = dateIn.getFullYear(),
    mm = dateIn.getMonth() + 1,
    dd = dateIn.getDate(),
    string = String(10000 * yyyy + 100 * mm + dd);

  return `${string.substring(0, 4)}-${string.substring(
    4,
    6
  )}-${string.substring(6, 8)}`;
};

export const getFilterParams = (data) =>
  Object.entries(data).reduce(
    (filtersAcc, [filterKey, filterValues]) => ({
      ...filtersAcc,
      ...(Array.isArray(filterValues)
        ? { [`${filterKey}[]`]: filterValues }
        : { [`${filterKey}`]: filterValues }),
    }),
    {}
  );

export const filterEmptyParams = (data) =>
  Object.entries(data).reduce(
    (acc, [key, value]) =>
      value?.toString()?.length ? { ...acc, [key]: value } : acc,
    {}
  );

export const paramsSerializer = (params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        searchParams.append(`${key}`, item);
      });
    } else {
      if (value) {
        searchParams.append(key, value);
      }
    }
  });

  return searchParams.toString();
};

export const handleResponseErrors = (response, callback, toast) => {
  if (response?.toast) {
    if (response.toast.success) {
      toast.success(response.toast.success[0]);
    }

    if (response.toast.alert) {
      toast.error(response.toast.alert[0]);
    }

    if (response.toast.notice) {
      toast.info(response.toast.notice[0]);
    }

    if (response.toast.warning) {
      toast.warning(response.toast.warning[0]);
    }

    return;
  }

  const remappedErrors = Object.entries(response.errors).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: Array.isArray(value) ? value[0] : value,
    }),
    {}
  );

  callback(remappedErrors);
};
